export const makeKeyForCartProductPriceMap = (
  id: number,
  downPayTime: number,
): string => {
  return `cartItemId-${id}_downPayTime-${downPayTime}`;
};

export const makePriceStringForCartProductPriceMap = (
  paymentPrice: string,
  paymentPriceUnit: string,
): string => {
  return `${paymentPrice} ${paymentPriceUnit}`;
};
